export const SOFTWARE_BUG_ID = 1;
export const SUGGESTION_ID = 2;

export const SOFTWARE_BUG_TITLE = 'Software bug';
export const SOFTWARE_SUGGESTION_TITLE = 'Suggestion';

export const CATEGORY_TECHNICAL_SUPPORT = [
  {
    id: SOFTWARE_BUG_ID,
    title: 'Software bug',
    name: 'Software bug',
    isActive: true,
    checked: false
  },
  {
    id: SUGGESTION_ID,
    title: 'Suggestion',
    name: 'Suggestion',
    isActive: false,
    checked: false
  }
];



// WEBPACK FOOTER //
// ./src/constants/categoryTechnicalSupport.js